(function ($, undefined) {
	'use strict';
	var formValidator;
	var locationsUtils;
	var utils;

	var init = function () {
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;
		utils = Fw.component.models().utils;

		$('#analytics-checklist-input').on('change', onChecklistChange);
		$('.remove-checklist-btn').on('click', removeBtn);
		$('.open-modal').on('click', onEditAnalytics);
		$('#saveAnalyticsDetails').on('click', saveAnalyticsDetails);
	};

	function onEditAnalytics(){
		var field21=$("#field21").val();
		if(field21!=undefined && field21!=""){
			utils.fetchGenDatas({ids: field21}, (gendatas) => {
				let checklists = gendatas;
				
				for(var i=0;checklists!=undefined && i<checklists.length;i++){
					const id = checklists[i].id;
					const text = checklists[i].field2;
		
					const button = $('.add-modify-page-inner-item-ctn-edit-item_template');
					
					const clone = button.clone(true, true).removeClass('add-modify-page-inner-item-ctn-edit-item_template');
					$("#analytics-checklist-input>option[value='"+id+"']").remove();
					
					clone.attr('data-id', id);
					clone.find('.add-modify-page-inner-item-ctn-edit-item__text div').text(text);
					$('.sb-checklists-container').append(clone);
				}
			});
		}
	}
	function onChecklistChange({ currentTarget }) {
		const id = currentTarget.value;
		
		const button = $('.add-modify-page-inner-item-ctn-edit-item_template');
		const index = currentTarget.selectedIndex;
		
		const selected = currentTarget.options[index];
		const clone = button.clone(true, true).removeClass('add-modify-page-inner-item-ctn-edit-item_template');
		currentTarget.removeChild(selected);
		currentTarget.value = "";
		
		clone.attr('data-id', id);
		clone.find('.add-modify-page-inner-item-ctn-edit-item__text div').text(selected.text);
		$('.sb-checklists-container').append(clone);
	}

	function removeBtn({ currentTarget }) {
		let button = $(currentTarget).closest('.add-modify-page-inner-item-ctn-edit-item');
		let id = button.attr('data-id');
		$('#analytics-checklist-input').append(`<option value="${id}">${button.text()}</option>`);
		button.remove();
	}

	function saveAnalyticsDetails(e){
		var ids="";
		$(".add-modify-page-inner-item-ctn-edit-item:not(.add-modify-page-inner-item-ctn-edit-item_template)").each((i,el)=>{
			var ele=$(el);
			if(ele.attr("data-id")!=undefined && ele.attr("data-id")>0)
				ids+=ids!=""?","+ele.attr("data-id"):ele.attr("data-id");
		});

		if(ids!=null && ids!=[]){
			utils.updateGenDataFields($(e.currentTarget).attr("data-id"), ['field21'], [ids], ()=>{location.reload()});
		}else utils.updateGenDataFields($(e.currentTarget).attr("data-id"), ['field21'], [null], ()=>{location.reload()});
	}
	
	$(window).ready(function () {
		init();
	});
})(jQuery);